import { TitanSprite } from "@lib/titan2/dist/game/control/TitanSprite";
import { AbstractView } from "@lib/titan2/dist/game/view/AbstractView";
import { DestroyUtil } from "@lib/titan2/dist/util/view/DestroyUtil";
import { ViewUtils } from "@lib/titan2/dist/util/view/ViewUtils";
/**
 * PayTableIcon.ts
 */
export class PayTableIcon extends AbstractView {
    constructor(properties, portraitProperties) {
        super(properties, portraitProperties);
        this.run();
    }
    createProperties(properties) {
        super.createProperties(properties);
        this.uiProperties = properties;
    }
    create() {
        if (this.uiProperties.iconProperties) {
            this.sprite = TitanSprite.createSprite(this, "icon", this.uiProperties.iconProperties);
        }
        if (this.uiProperties.multiplierFieldProperties) {
            this.multiplierValue = ViewUtils.createField(this, this.uiProperties.multiplierFieldProperties);
        }
        if (this.uiProperties.freeSpinValueProperties) {
            this.freeSpinsValue = ViewUtils.createField(this, this.uiProperties.freeSpinValueProperties);
        }
        if (this.uiProperties.freeSpinLabelProperties) {
            this.freeSpinsLabel = ViewUtils.createField(this, this.uiProperties.freeSpinLabelProperties);
        }
    }
    destroy() {
        super.destroy();
        DestroyUtil.destroy(this.sprite);
        DestroyUtil.destroy(this.multiplierValue);
        DestroyUtil.destroy(this.freeSpinsValue);
        DestroyUtil.destroy(this.freeSpinsLabel);
        this.sprite = null;
        this.multiplierValue = null;
        this.freeSpinsValue = null;
        this.freeSpinsLabel = null;
    }
    setMultiplier(value) {
        if (this.multiplierValue) {
            this.multiplierValue.setText("X" + String(value));
        }
    }
    setFreeSpins(value) {
        if (this.freeSpinsValue) {
            this.freeSpinsValue.setText(String(value));
        }
    }
}
//# sourceMappingURL=PayTableIcon.js.map